import { lazy } from 'react';

export const SalesListLazy = lazy(
  () => import('@/pages/transaction/sales/SalesList'),
);
export const PosSalesLazy = lazy(
  () => import('@/pages/transaction/sales/pos/PosSales'),
);
export const PosOrderLazy = lazy(
  () => import('@/pages/transaction/sales/pos/PosOrder'),
);
export const SalesLazy = lazy(() => import('@/pages/transaction/sales/Sales'));

export const UtilCodeWindowFormLazy = lazy(
  () => import('@/utils/transaction/forms/UtilCodeWindowForm'),
);

export const PurchaseLazy = lazy(
  () => import('@/pages/transaction/purchase/Purchase'),
);
export const PurchaseListLazy = lazy(
  () => import('@/pages/transaction/purchase/PurchaseList'),
);

export const ReceiveKarigarLazy = lazy(
  () => import('@/pages/transaction/receive/ReceiveKarigar'),
);
export const ReceiveKarigarListLazy = lazy(
  () => import('@/pages/transaction/receive/ReceiveKarigarList'),
);

export const ReceivePartyLazy = lazy(
  () => import('@/pages/transaction/receive/ReceiveParty'),
);
export const ReceivePartyListLazy = lazy(
  () => import('@/pages/transaction/receive/ReceivePartyList'),
);

export const ReceiveRefineLazy = lazy(
  () => import('@/pages/transaction/receive/ReceiveRefine'),
);
export const ReceiveRefineListLazy = lazy(
  () => import('@/pages/transaction/receive/ReceiveRefineList'),
);

export const PurchaseReturnLazy = lazy(
  () => import('@/pages/transaction/return/PurchaseReturn'),
);
export const PurchaseReturnCodeWindowLazy = lazy(
  () => import('@/pages/transaction/return/PurchaseReturnCodeWIndow'),
);
export const PurchaseReturnListLazy = lazy(
  () => import('@/pages/transaction/return/PurchaseReturnList'),
);

export const SalesReturnLazy = lazy(
  () => import('@/pages/transaction/return/SalesReturn'),
);
export const SalesReturnListLazy = lazy(
  () => import('@/pages/transaction/return/SalesReturnList'),
);

export const DisableDynamicCodeWindowLazy = lazy(
  () => import('@/pages/transaction/reuse/DisableDynamicCodeWindow'),
);

export const SalesOrderLazy = lazy(
  () => import('@/pages/transaction/sales order/SalesOrder'),
);
export const SalesOrderListLazy = lazy(
  () => import('@/pages/transaction/sales order/SalesOrderList'),
);
